function Error({error}) {
    return (
        <></>
    );
}

export default Error;